import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-OutdoorSuperSite",
  "use": "svg-icon-OutdoorSuperSite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-OutdoorSuperSite\"><path d=\"M0 0h16v8H7.999L8 16H6V8H0V0zm2 2v4h12V2H2z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol